import { Component, Input, OnInit } from '@angular/core';
import { DAILY_DIGEST_TYPE, INSTANT_EMAIL_SECTION_TYPE } from '../constants';
import { AccountGroupNotificationsService, ProductNotifications } from './account-group-notifications.service';

@Component({
  selector: 'app-account-group-notifications',
  templateUrl: './account-group-notifications.component.html',
  styleUrls: ['./account-group-notifications.component.scss'],
})
export class AccountGroupNotificationsComponent implements OnInit {
  @Input()
  accountGroupId: string;
  @Input()
  subjectId: string;

  selectedNotification: ProductNotifications;
  notificationSections: ProductNotifications[];

  errorGettingSettings = false;

  disabledSections: string[] = [];

  constructor(private accountGroupNotificationsService: AccountGroupNotificationsService) {}

  ngOnInit(): void {
    this.accountGroupNotificationsService.getSettings(this.accountGroupId, this.subjectId).subscribe(
      (response) => {
        this.errorGettingSettings = false;
        this.selectedNotification = response[0];
        this.notificationSections = response;
        this.checkForDisabledSections();
      },
      (err) => {
        console.error(err);
        this.errorGettingSettings = true;
      },
    );
  }

  selectNotification(product: ProductNotifications): void {
    this.selectedNotification = product;
    this.checkForDisabledSections();
  }

  private checkForDisabledSections(): void {
    this.disabledSections = [];
    if (
      this.notificationSections &&
      this.notificationSections.length > 0 &&
      this.notificationSections[0].sections.length > 1
    ) {
      // Check if the instant email is disabled
      if (!this.notificationSections[0].sections[0].value) {
        this.disabledSections.push(INSTANT_EMAIL_SECTION_TYPE);
      }
      // Check if the daily digest is disabled
      if (!this.notificationSections[0].sections[1].value) {
        this.disabledSections.push(DAILY_DIGEST_TYPE);
      }
    }
  }
}
